import { css } from 'aphrodite';
import { ReactNode, useState } from 'react';
import { styleSheet } from '../styles';

type Props = React.PropsWithChildren<{
	button?: ReactNode;
}>;

export const CustomLabel = ({ children, button }: Props) => {
	const [showButton, setShowButton] = useState(false);

	return (
		<div
			className={css(styleSheet.customLabelWrap)}
			onMouseEnter={() => setShowButton(true)}
			onMouseLeave={() => setShowButton(false)}
		>
			{showButton && <>{button}</>}
			{children}
		</div>
	);
};
